import {call, put, takeEvery, takeLatest} from 'redux-saga/effects'
import * as actions from "./actions";
import * as modalActions from "../ui/modal/actions";
import uuid from "uuid";
import * as ajaxErrors from './errorMessages';
import * as ajaxUtil from '../ajax/ajaxUtil';
import {Saga} from "./actions";

function* handleError({error}) {

  let errorObj = ajaxErrors.AjaxErrorTranslator.getErrorObjectForStatusCode("fallback");

  if(ajaxUtil.isXhrFailure(error))
  {
    errorObj = ajaxUtil.translateXhrError(error);
  }

  yield put(modalActions.openModal({
    id: uuid.v4(),
    type: 'confirmation',
    title: errorObj.title,
    text: errorObj.message,
    onConfirm: Saga.reload(),
    confirmLabel: 'Reload',
    closeLabel: 'Close',
  }));

}

function* handleReload() {
  window.location.reload();
}


function* subscriptionSaga() {
  yield takeLatest(actions.SAGA_SET_ERROR, handleError);
  yield takeLatest(actions.SAGA_RELOAD_ERROR, handleReload);
}

export default subscriptionSaga;